// MiniPlayground.tsx  – drop this into src/App.tsx for a demo
import React, { useState } from "react";
import { runJsCode, runPyCode } from "../utils/runCode";
import CodeEditor from "../components/codeEditor";
import { JSONInputField } from "../components/pixie/common";
import { Stack } from "@mui/material";

type Lang = "javascript" | "python";

const STARTER: Record<Lang, string> = {
  javascript: `function transform(data) {
  return data.map(x => x * 2);
}`,
  python: `def transform(data):
    return [x * 2 for x in data]`,
};

export default function MiniPlayground() {
  const [lang, setLang] = useState<Lang>("javascript");
  const [code, setCode] = useState(STARTER[lang]);
  const [out, setOut] = useState<string>("");

  const [data, setData] = useState<number[]>([1, 2, 3]); // sample input
  const [fnName, setFnName] = useState<string>("transform");

  // keep starter snippet in sync when language toggles
  const onLangChange = (l: Lang) => {
    setLang(l);
    setCode(STARTER[l]);
    setOut("");
  };

  const run = async () => {
    setOut("⏳ running…");
    try {
      const res =
        lang === "python"
          ? await runPyCode(code, data, fnName)  // auto-detects ‘transform’
          : await runJsCode(code, data, fnName); // ditto
      setOut(JSON.stringify(res, null, 2));
    } catch (e) {
      setOut(String(e));
    }
  };

  return (
    <div style={{ fontFamily: "sans-serif", maxWidth: 680 }}>
      <Stack>
        <label>Function name:&nbsp;
          <input
            type="text"
            value={fnName}
            onChange={e => setFnName(e.target.value)}
            placeholder="transform"
            style={{ width: 150 }}
          />
        </label>
        <label>
          Input data:&nbsp;
          <JSONInputField
            value={data}
            onChange={setData}
          />
        </label>
        <label>
          Language:&nbsp;
          <select value={lang} onChange={e => onLangChange(e.target.value as Lang)}>
            <option value="javascript">JavaScript / TS</option>
            <option value="python">Python</option>
          </select>
        </label>
      </Stack>

      <CodeEditor
        language={lang}
        code={code}
        onChange={setCode}
        height={260}
      />

      <button onClick={run} style={{ marginTop: 10 }}>
        ▶ Run
      </button>

      <pre style={{ background: "#f6f8fa", padding: 10, marginTop: 10 }}>
        {out}
      </pre>
    </div>
  );
}
